import axios from 'axios';

/**
 * Cancel any ongoing request(s).
 * @param {axios token source} tokenSource
 * Can be generated with the helper method getCancellationToken
 * These are one time use tokens. Generate a new token each time with getCancellationToken
 */
const cancelRequest = tokenSource => {
	tokenSource.cancel();
};

/**
 * Helper function to get a cancellation token source
 * @returns axios cancellation token source.
 * Use this to generate a token using the Token() method which needs to be passed to each request.
 * Pass this source to the cancelToken helper function to cancel any ongoing request(s).
 */
const getCancelTokenSource = () => axios.CancelToken.source();

/**
 * Returns whether a passed in error object is an axios cancel error.
 * If the ongoing request is canceled, an error is thrown. Pass the error
 * to this routine to verify that it is a cancellation error.
 * @param {error object} error
 * @returns boolean
 */
const isCancel = error => axios.isCancel(error);

export { cancelRequest, getCancelTokenSource, isCancel };
